<template>
    <div>
        <div class="card">
            <Toolbar class="mb-4">
                <template #start>
                    <Button label="Nuevo" icon="pi pi-plus" class="p-button-success mr-2" @click="openNew" />
                    <!--
                    <Button label="Eliminar" icon="pi pi-trash" class="p-button-danger" @click="confirmDeleteSelected" :disabled="!selectedProducts || !selectedProducts.length" />
                    -->
                    <Button label="Nuevo Ingreso" icon="pi pi-plus" class="p-button-primary" @click="editProductGenericStock()"  />
                    
                </template>

                <template #end>
                    <span class="mr-2 product-badge status-stock" v-if="almac">{{almac}}</span>
                    <Dropdown
                            id="filter_almacen_id"
                            @change="filterStock();"
                            v-model="filter_almacen_id"
                            :options="almacenes_filtro"
                            optionLabel="name"
                            optionValue="id"
                            class="mr-2"
                            required="false"
                            autofocus
                      />    
                    <FileUpload mode="basic" accept="image/*" :maxFileSize="1000000" label="Importar" chooseLabel="Importar" class="mr-2 inline-block" />
                    <Button label="Exportar" icon="pi pi-upload" class="p-button-help" @click="exportCSV($event)"  />
                </template>
            </Toolbar>

            <div  class="col-12" v-if="show_error">
                <div :class="'st_bg_color'">
                  <i class="pi pi-eye ml-2" ></i>
                  <span> El Insumo tiene movimientos y no puede ser eliminado!</span>          
                </div>        
            </div>

            <DataTable ref="dt" :value="products" v-model:selection="selectedProducts" dataKey="id" 
                :paginator="true" :rows="10" :filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[5,10,25]"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products" responsiveLayout="scroll">
                <template #header>
                    <div class="table-header flex flex-column md:flex-row md:justiify-content-between">
						<h5 class="mb-2 md:m-0 p-as-md-center">Insumos / Materia Primas</h5>
						<span class="p-input-icon-left">                        
                            <i class="pi pi-search" />
                            <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                        </span>
					</div>
                </template>
                <!--
                    <Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column>
                -->

                <Column field="name" header="Nombre" :sortable="true" style="min-width:12rem"></Column>

                <Column field="description" header="Descripción" :sortable="true" style="min-width:16rem"></Column>

                <Column field="price" header="Precio" :sortable="true" style="min-width:8rem">
                    <template #body="slotProps">
                        {{formatCurrency(slotProps.data)}}
                    </template>
                </Column>

                <Column field="unidad" header="Unidad" :sortable="true" style="min-width:6rem">
                    <template #body="slotProps">
                        <span style="text-transform: uppercase">{{formatUnity(slotProps.data.unidad)}}</span>
                    </template>
                </Column>

                <Column field="quantity" header="Cant" :sortable="true" style="min-width:4rem">
                    <template #body="slotProps">
                        <span class="product-badge status-stock"  @click="showStockDetail(slotProps.data)" v-tooltip="getQuantities(slotProps.data)">{{slotProps.data.quantity}}</span>                        
                    </template>
                </Column>

                <Column field="stock_min" header="Stock Min." :sortable="true" style="min-width:4rem">
                    <template #body="slotProps">
                        {{slotProps.data.stock_min}}
                    </template>
                </Column>
                
                <Column field="quantity" header="Estado" :sortable="true" style="min-width:11rem">
                    <template #body="slotProps">
                        <!--
                        <span :class="'product-badge status-outofstock'">
                            SIN STOCK
                        </span>
                        -->
                        <span :class="'product-badge status-' + (slotProps.data.status ? slotProps.data.status.toLowerCase() : '')">
                            {{ getStatusName(slotProps.data.status) }}
                        </span> 

                    </template>
                </Column>

                <Column :exportable="false" style="min-width:8rem">
                    <template #body="slotProps">
                        <Button icon="pi pi-plus" class="p-button-rounded p-button-primary mr-2" @click="editProductStock(slotProps.data)" />
                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editProduct(slotProps.data)" />
                        <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="confirmDeleteProduct(slotProps.data)" />
                    </template>
                </Column>

            </DataTable>
        </div>

        <Dialog v-model:visible="productDialog" :style="{width: '600px'}" header="Detalles del insumo" :modal="true" class="p-fluid">            
            <div class="field">
                <label for="name">Nombre</label>
                <InputText id="name" v-model.trim="product.name" required="true" autofocus :class="{'p-invalid': submitted && !product.name}" />
                <small class="p-error" v-if="submitted && !product.name">Nombre es requerido.</small>
            </div>
            <div class="field">
                <label for="description">Descripción</label>
                <Textarea id="description" v-model="product.description" required="true" rows="3" cols="20" />
            </div>

            <div class="field">
                <label class="mb-3">Proveedor Sugerido</label>
                <AutoComplete                  
                  id="proveedor_id"
                  v-model="product.proveedor"
                  :options="proveedores"
                  class="inputfield w-full"
                  optionLabel="name"
                  optionValue="id"
                  required="false"
                  :dropdown="true"
                  field="name"
                  :suggestions="filteredProvider"
                  @complete="searchProvider($event)"
                  @item-select="newItemProvider = selectedProvider"                  
                />
                <!--
                <Dropdown
                      id="proveedor_id"
                      v-model="product.proveedor_id"
                      :options="proveedores"
                      class="w-full"
                      optionLabel="name"
                      optionValue="id"
                      required="false"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.proveedor_id }"
                />
                -->
            </div>

            <div class="formgrid grid">
                <div class="field col-3">
                    <label for="inventoryStatus" class="mb-3">Estado</label>
                    <Dropdown id="inventoryStatus" v-model="product.inventoryStatus" :options="statuses" optionLabel="label" placeholder="Select a Status">
                        <template #value="slotProps">
                            <div v-if="slotProps.value && slotProps.value.value">
                                <span :class="'product-badge status-' +slotProps.value.value">{{slotProps.value.label}}</span>
                            </div>
                            <div v-else-if="slotProps.value && !slotProps.value.value">
                                <span :class="'product-badge status-' +slotProps.value.toLowerCase()">{{slotProps.value}}</span>
                            </div>
                            <span v-else>
                                {{slotProps.placeholder}}
                            </span>
                        </template>
                    </Dropdown>
                </div>

                <div class="field col-3">
                    <label class="mb-3" for="price">Valor</label>
                    <InputNumber id="price" v-model="product.valor" mode="currency" currency="USD" locale="en-US" />
                </div>
                <div class="field col-3">
                    <label class="mb-3" for="currency" style="display: block">Moneda</label>
                    <Dropdown
                        id="currency"
                        v-model="product.currency"
                        :options="monedas"
                        class="w-full"
                        optionLabel="label"
                        optionValue="value"
                        required="false"
                        autofocus
                    />
                </div>
                <div class="field col-3">
                    <label class="mb-3" for="stock_min">Stock Mín.</label>
                    <InputNumber id="stock_min" v-model="product.stock_min"  />
                </div>

                <div class="field col-5">
                    <label class="mb-3">Unidad Compra</label>
                    <Dropdown
                          id="unidad"
                          v-model="product.unidad"
                          :options="units"
                          class="w-full"
                          optionLabel="name"
                          optionValue="id"
                          required="false"
                          autofocus
                          :class="{ 'p-invalid': submitted && !product.unidad }"
                    />
                </div>

                <div class="field col-5">
                    <label class="mb-3" for="uses_id">Unidad Uso</label>
                    <Dropdown
                          id="uses_id"
                          v-model="product.uses_unit"
                          :options="units"
                          class="w-full"
                          optionLabel="name"
                          optionValue="id"
                          required="false"
                          autofocus
                          :class="{ 'p-invalid': submitted && !product.uses_unit }"
                    />
                </div>

                <div class="field col-2">
                    <label class="mb-3" for="quantity">Cant.</label>
                    <InputNumber disabled id="quantity" v-model="product.quantity" integeronly />
                </div>                
            </div>


            <div class="card">
                <div class="">
                  <div class="formgrid grid">
                    <div class="field col-4">
                      <label for="base">Fecha Remito</label>
                      <InputText
                        id="fecha_remito"
                        type="date"
                        class="inputfield w-full"
                        v-model.trim="fecha_remito"
                        autofocus
                      />
                    </div>

                    <div class="field col-4">
                      <label for="base">Nro. Remito</label>
                      <InputText
                        id="remito"
                        v-model.trim="remito"
                      />
                    </div>

                    <div class="field col-4">
                      <label for="base">Nro. Orden Compra</label>
                      <InputText
                        id="orden"
                        v-model.trim="orden"
                        autofocus
                      />
                    </div>
                    <div class="field col-6">
                      <label for="almacen_id">Stock por Depósito</label>
                      <Dropdown
                            id="almacen_id"
                            v-model="almacen_id"
                            :options="almacenes"
                            class="w-full"
                            optionLabel="name"
                            optionValue="id"
                            required="false"
                            autofocus
                      />
                      
                    </div>

                    <div class="field col-3">
                      <label for="base">Cant.</label>
                      <InputText
                        id="quantity"
                        v-model.trim="quantity"
                        autofocus
                        :disabled="!almacen_id"
                      />    
                    </div>

                  <div class="field col-3">        
                    <Button :disabled="! almacen_id && quantity > 0"  @click="addItemDetalle()" label="Agregar" 
                      class="p-button-success inputfield w-full mt-5" />
                  </div>
                </div>

                <DataTable
                  :value="product.almacenes_insumos"
                  dataKey="id" 
                  class="p-datatable-sm"
                  responsiveLayout="scroll"
                >
                  <Column field="id" header="" >
                    <template #body="slotProps">
                        <Button icon="pi pi-times" class="p-button-rounded p-button-danger" @click="delItemAlmacen(slotProps.data.id)"></Button>
                    </template>
                  </Column>
                  <Column field="name" header="Depósito">
                  <template #body="slotProps">
                    <b>
                      {{ slotProps.data.name }}
                    </b>
                    </template>
                  </Column>

                  <Column field="name" header="Cantidad">
                  <template #body="slotProps">
                    <b>
                      {{ slotProps.data.quantity }}
                    </b>
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>

            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
                <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="saveProduct" />
            </template>
        </Dialog>


        <Dialog v-model:visible="productDialogStock" :style="{width: '600px'}" header="Traslados de Stock" :modal="true" class="p-fluid">     
            <div class="field">
                <h2>{{product.name}}</h2>
            </div>
            
            <div class="card">
                <div class="">
                  <div class="formgrid grid">
                    
                    <div class="field col-9">
                      <label for="almacen_origen">Origen</label>
                      <Dropdown
                            id="almacen_origen"
                            v-model="almacen_id"
                            :options="almacenes"
                            class="w-full"
                            optionLabel="name"
                            optionValue="id"
                            required="false"
                            autofocus
                      />
                      
                    </div>

                    <div class="field col-3">
                      <label for="base">Cant.</label>
                      <InputText
                        id="quantity"
                        v-model.trim="quantity"
                        autofocus
                        :disabled="!almacen_id"
                      />    
                    </div>

                    <div class="field col-9">
                      <label for="to_almacen_id">Destino</label>
                      <Dropdown
                            id="to_almacen_id"
                            v-model="to_almacen_id"
                            :options="almacenes"
                            class="w-full"
                            optionLabel="name"
                            optionValue="id"
                            required="false"
                            autofocus
                      />                      
                    </div>

                    <div class="field col-3">
                        <Button :disabled="! almacen_id && quantity > 0"  @click="TransferStock()" label="Transferir" 
                          class="p-button-success inputfield w-full w-100 mt-5" />
                    </div>
                </div>

                <DataTable
                  :value="product.almacenes_insumos"
                  dataKey="id" 
                  class="p-datatable-sm"
                  responsiveLayout="scroll"
                >
                  <Column field="name" header="Depósito">
                  <template #body="slotProps">
                    <b>
                      {{ slotProps.data.name }}
                    </b>
                    </template>
                  </Column>

                  <Column field="name" header="Cantidad">
                  <template #body="slotProps">
                    <b>
                      {{ slotProps.data.quantity }}
                    </b>
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>

            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="hideDialogStock"/>
                <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="saveProductStock" />
            </template>
        </Dialog>

        <Dialog v-model:visible="productDialogGenericStock" :style="{width: '600px'}" header="Nuevo Ingreso Mercaderia" :modal="true" class="p-fluid">
            <div class="field">
                <label class="mb-3">Insumo</label>
                <AutoComplete                  
                  id="insumo_id"
                  v-model="product"
                  :options="products"
                  class="inputfield w-full"
                  optionLabel="name"
                  optionValue="id"
                  required="false"
                  :dropdown="true"
                  field="name"
                  :suggestions="filteredInsumo"
                  @complete="searchInsumo($event)"
                  @item-select="newItemInsumo = selectedInsumo"                  
                />
            </div>
            
            <div class="card">
                <div class="">
                  <div class="formgrid grid">
                    <div class="field col-4">
                      <label for="base">Fecha Remito</label>
                      <InputText
                        id="fecha_remito"
                        type="date"
                        class="inputfield w-full"
                        v-model.trim="fecha_remito"
                        autofocus
                      />
                    </div>

                    <div class="field col-4">
                      <label for="base">Nro. Remito</label>
                      <InputText
                        id="remito"
                        v-model.trim="remito"
                        autofocus
                      />
                    </div>

                    <div class="field col-4">
                      <label for="base">Nro. Orden Compra</label>
                      <InputText
                        id="orden"
                        v-model.trim="orden"
                        autofocus
                      />
                    </div>
                    <div class="field col-6">
                      <label for="almacen_origen">Depósito</label>
                      <Dropdown
                            id="almacen_origen"
                            v-model="almacen_id"
                            :options="almacenes"
                            class="w-full"
                            optionLabel="name"
                            optionValue="id"
                            required="false"
                            autofocus
                            :disabled="! product"
                      />                      
                    </div>

                    <div class="field col-3">
                      <label for="base">Cant.</label>
                      <InputText
                        id="quantity"
                        v-model.trim="quantity"
                        autofocus
                        :disabled="!almacen_id"
                      />    
                    </div>

                    <div class="field col-3">
                        <Button :disabled="! almacen_id && quantity > 0 || ! product"  @click="TransferGenericStock()" label="Agregar" 
                          class="p-button-success inputfield w-full w-100 mt-5" />
                    </div>
                </div>

                <DataTable
                  :value="product.almacenes_insumos"
                  dataKey="id" 
                  class="p-datatable-sm"
                  responsiveLayout="scroll"
                >
                  <Column field="name" header="Depósito">
                  <template #body="slotProps">
                    <b>
                      {{ slotProps.data.name }}
                    </b>
                    </template>
                  </Column>

                  <Column field="name" header="Cantidad">
                  <template #body="slotProps">
                    <b>
                      {{ slotProps.data.quantity }}
                    </b>
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>

            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="hideDialogGenericStock"/>
                <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="saveProductGenericStock" />
            </template>
        </Dialog>

        <Dialog v-model:visible="productDialogStockDetail" :style="{width: '600px'}" header="Stock por Depósito" :modal="true" class="p-fluid">     
            <div class="field">
                <h2>{{product.name}}</h2>
            </div>
            
            <div class="card">
                <div class="">
                  
                <DataTable
                  :value="product.almacenes_insumos"
                  dataKey="id" 
                  class="p-datatable-sm"
                  responsiveLayout="scroll"
                >
                  <Column field="name" header="Depósito">
                  <template #body="slotProps">
                    <b>
                      {{ slotProps.data.name }}
                    </b>
                    </template>
                  </Column>

                  <Column field="name" header="Cantidad">
                  <template #body="slotProps">
                    <b>
                      {{ slotProps.data.quantity }}
                    </b>
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>

            
        </Dialog>

        <Dialog v-model:visible="deleteProductDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span v-if="product">Seguro quieres eliminar <b>{{product.name}}</b>?</span>
            </div>
            <template #footer>
                <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductDialog = false"/>
                <Button label="Sí" icon="pi pi-check" class="p-button-text" @click="deleteProduct" />
            </template>
        </Dialog>

        <Dialog v-model:visible="deleteProductsDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span v-if="product">Are you sure you want to delete the selected products?</span>
            </div>
            <template #footer>
                <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductsDialog = false"/>
                <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteSelectedProducts" />
            </template>
        </Dialog>


	</div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import { useToast } from 'primevue/usetoast';
import ProductService from './../services/crud.service';
import CrudService from './../services/crud.service';

export default {
    data() {
        return {
          routeName: null,
          filteredProvider: null,
          filteredInsumo: null,
          proveedor: null,
          almac: null,
          insumo: null,
          newItemProvider: null,
          newItemInsumo: null,
          selectedProvider: null,
          selectedInsumo: null,
          products: null,
          productsOrig: null,
          productDialog: false,
          productDialogStock: false,          
          productDialogGenericStock: false,          
          productDialogStockDetail: false,
          show_error: false,
          deleteProductDialog: false,
          deleteProductsDialog: false,
          product: {},
          selectedProducts: null,
          filters: {},
          submitted: false,
          validationErrors: [],
          almacenes: [],
          almacenes_filtro: [],
          almacenes_full: [],
          filter_almacen_id: null,
          //almacenes_insumos: null,
          almacen_id: null,
          remito: null,
          fecha_remito: new Date().toISOString().slice(0,10),
          orden: null,
          to_almacen_id: null,
          quantity: 0,
          proveedores: {},          
          monedas: [
            { value: 'USD', label: "Dolar Divisa U$S" },
            { value: 'CASH', label: "Dolar Billete USD" },
            { value: 'PESOS', label: "Peso $" }
          ],
        };
      },
      created() {
        // get route name
        this.routeName = this.$route.name;
        //this.initFilters();
      },
      mounted() {
        CrudService.getCRUD('almacenes').then((data) => {
            this.almacenes = data;
            this.almacenes_filtro = data;
            this.almacenes_full = data;
            this.almacenes_filtro.push;
            this.almacenes_filtro.push({
                    id: 0,
                    name: 'TODOS',
                });
        });        
        CrudService.getCRUD('unidades').then((data) => (this.units = data));
        CrudService.getCRUD('proveedor').then((data) => {
            this.proveedores = data;
        });

        CrudService.getCRUD('Insumos').then(
          (data) => {
            this.products = data
            this.products.forEach((item) => {
                item.quantity_orig = item.quantity
                item.almacenes_insumos.forEach((almacen) => {
                    almacen.id = almacen.almacen_id;
                    almacen.quantity = almacen.stock;
                    let alm = this.almacenes.filter((almac) => almac.id == almacen.almacen_id);
                    almacen.name = alm && alm.length > 0 ? alm[0].name : '';                        
                });
            }); 
            this.productsOrig = this.products;
            if (this.$route.params.id != null) {
                this.filterStock(this.$route.params.id)
            }
        });
      },
    setup() {
        onMounted(() => {
            /*
            CrudService.getCRUD('almacenes').then((data) => (almacenes.value = data));
            CrudService.getCRUD('insumos','insumo').then(data => {
                products.value = data
                products.value.forEach((item) => {
                    item.almacenes_insumos.forEach((almacen) => {
                        almacen.id = almacen.almacen_id;
                        almacen.quantity = almacen.stock;
                        let alm = almacenes.value.filter((almac) => almac.id == almacen.almacen_id);
                        almacen.name = alm && alm.length > 0 ? alm[0].name : '';                        
                    });
                }); 
                console.log('products.value')
                console.log(products.value)
            });
            */
        })

        const toast = useToast();
        const dt = ref();
        const products = ref();
        const productsOrig = ref();
        const proveedores = ref();
        const proveedor = ref();
        const almac = ref();
        const insumo = ref();
        const productDialog = ref(false);
        const productDialogStock = ref(false);
        const productDialogGenericStock = ref(false);
        const productDialogStockDetail = ref(false);
        const deleteProductDialog = ref(false);
        const show_error = ref(false);
        const deleteProductsDialog = ref(false);
        const product = ref({});
        //const productService = ref(new ProductService());
        const selectedProducts = ref();
        const filters = ref({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        });
        const submitted = ref(false);
        const statuses = ref([
	     	{label: 'EN STOCK', value: 'instock'},
	     	{label: 'BAJO STOCK', value: 'lowstock'},
	     	{label: 'SIN STOCK', value: 'outofstock'}
        ]);

        const units = ref([
            {label: 'Kilo', value: '1'},
        ]);

        const estados = ref({
            'INSTOCK': "EN STOCK",
            'LOWSTOCK': "BAJO STOCK",
            'OUTOFSTOCK': "SIN STOCK"
        });

        const almacenes = ref();
        const almacenes_filtro = ref();
        const almacenes_full = ref();
        const filter_almacen_id = ref();
        //const almacenes_insumos = ref();
        const almacen_id = ref();
        const to_almacen_id = ref();
        const quantity = ref();
        const remito = ref();
        const fecha_remito = ref();
        const orden = ref();
        const filteredProvider = ref();
        const filteredInsumo = ref();
        const newItemProvider =  ref();
        const newItemInsumo =  ref();
        const selectedProvider = ref();
        const selectedInsumo = ref();

        const searchProvider = (event) => {
          setTimeout(() => {
            if (!event.query.trim().length) {
              filteredProvider.value = [...proveedores.value];
            } else {
              filteredProvider.value = proveedores.value.filter((prov) => {
                return prov.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase());
              });
            }
          }, 250);
        };
        
        const searchInsumo = (event) => {
          setTimeout(() => {
            if (! event.query.trim().length) {
              filteredInsumo.value = [...products.value];
            } else {
              filteredInsumo.value = products.value.filter((insumo) => {
                return insumo.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase());
              });
            }
          }, 250);
        };
        
        const formatUnity = (value) => {
            let unit = units.value.filter((item) => item.id == value);
            if (unit.length > 0) {
                return unit[0].name;
            }
            return ''

        };
        const formatCurrency = (value) => {
            if (value.valor) {
                let currency = value.currency == 'PESOS' ? '$' : value.currency;
				return currency + " " + value.valor.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
            }
			return;
        };
        const openNew = () => {
            product.value = {};            
            submitted.value = false;
            productDialog.value = true;
        };
        const hideDialog = () => {
            productDialog.value = false;
            submitted.value = false;
        };
        const hideDialogStock = () => {
            productDialogStock.value = false;
            submitted.value = false;
        };
        const hideDialogGenericStock = () => {
            productDialogGenericStock.value = false;
            submitted.value = false;
        };
        const hideDialogStockDetail = () => {
            productDialogStockDetail.value = false;
            submitted.value = false;
        };
        const displayErrors = (errors) => {      
              for (let key in errors) {
                this.validationErrors.push({ "field": key, "message": errors[key] });
                let error = errors[key];
                this.$toast.add({
                  severity: "error",
                  summary: "Error!",
                  detail: error[0],
                  life: 3000,
                });
              }
        };
        const getStatusName = (index) => {
            let status = statuses.value.filter(val => val.value == index);
            if (status.length > 0) {
                return status[0].label;
            }
        };
        const saveProduct = () => {
            submitted.value = true;
            let proveedor = proveedores.value.filter((prov) => prov.id == product.value.proveedor.id);
            if (proveedor && proveedor.length) {
                product.value.proveedor_id = proveedor[0].id;
            }
            if (product.value.name.trim()) {
                if (product.value.id) { 
                    CrudService.updateCRUD('insumos','insumo', product.value).then(                        
                        (data) => {
                            let validationErrors = [];
                            if (data.status == 400) {
                              this.displayErrors(data.data);
                            } else {
                                products.value[findIndexById(data.data.id)] = data.data;
                                products.value[findIndexById(data.data.id)].almacenes_insumos.forEach((almacen) => {
                                    almacen.id = almacen.almacen_id;
                                    almacen.quantity = almacen.stock;
                                    let alm = almacenes.value.filter((almac) => almac.id == almacen.almacen_id);
                                    almacen.name = alm && alm.length > 0 ? alm[0].name : '';                        
                                });
                                product.value.inventoryStatus = data.status ? data.status : 'INSTOCK'; //product.value.inventoryStatus = product.value.inventoryStatus.value ? product.value.inventoryStatus.value : product.value.inventoryStatus;
                                toast.add({severity:'success', summary: 'Successful', detail: 'Products Deleted', life: 3000});
                                //$toast.add({severity:'success', summary: 'Éxito!', detail: 'Actualizado correctamente.', life: 3000});
                                productsOrig.value = productsOrig.value
                            }
                        });
                } else {
                    CrudService.createCRUD('insumos','insumo', product.value).then((data) => {                          
                        let validationErrors = [];
                        if (data.status == 400) {
                          this.displayErrors(data.data);                          
                        } else {
                            product.value.id = createId();
                            product.value.code = createId();
                            //product.value.image = 'product-placeholder.svg';
                            product.value.inventoryStatus = data.status ? data.status : 'INSTOCK';//product.value.inventoryStatus ? product.value.inventoryStatus.value : 'INSTOCK';
                            products.value.push(data.data);
                            products.value[findIndexById(data.data.id)].almacenes_insumos.forEach((almacen) => {
                                almacen.id = almacen.almacen_id;
                                almacen.quantity = almacen.stock;
                                let alm = almacenes.value.filter((almac) => almac.id == almacen.almacen_id);
                                almacen.name = alm && alm.length > 0 ? alm[0].name : '';                        
                            });
                            //products.value[findIndexById(product.value.id)] = product.value;
                            //$toast.add({severity:'success', summary: 'Éxito!', detail: 'Creado correctamente.', life: 3000});
                            productsOrig.value = products.value

                            toast.add({severity:'success', summary: 'Successful', detail: 'Products Deleted', life: 3000});
                          }
                        }
                      );                    
                }                
                productDialog.value = false;
                productGenericDialog.value = false;
                product.value = {};
            }            
        };
        const saveProductStock = () => {
            submitted.value = true;
            if (product.value.name.trim()) {
                if (product.value.id) { 
                    CrudService.updateCRUD('insumos-stock','insumo', product.value).then(
                        (data) => {
                            let validationErrors = [];
                            if (data.status == 400) {
                              this.displayErrors(data.data);
                            } else {
                                products.value[findIndexById(data.data.id)] = data.data;
                                products.value[findIndexById(data.data.id)].almacenes_insumos.forEach((almacen) => {
                                    almacen.id = almacen.almacen_id;
                                    almacen.quantity = almacen.stock;
                                    let alm = almacenes.value.filter((almac) => almac.id == almacen.almacen_id);
                                    almacen.name = alm && alm.length > 0 ? alm[0].name : '';                        
                                });
                                product.value.inventoryStatus = data.status ? data.status : 'INSTOCK'; 
                                productsOrig.value = products.value
                                toast.add({severity:'success', summary: 'Successful', detail: 'Actualizado correctamente', life: 3000});
                            }
                        });
                }                
                productDialogStock.value = false;
                productDialogGenericStock.value = false;
                productDialogStockDetail.value = false;
                product.value = {};
            }            
        };
        const saveProductGenericStock = () => {
            submitted.value = true;
            if (product.value.name.trim()) {
                if (product.value.id) { 
                    CrudService.updateCRUD('insumos-stock-sumar','insumo', product.value).then(
                        (data) => {
                            let validationErrors = [];
                            if (data.status == 400) {
                              this.displayErrors(data.data);
                            } else {
                                products.value[findIndexById(data.data.id)] = data.data;
                                products.value[findIndexById(data.data.id)].almacenes_insumos.forEach((almacen) => {
                                    almacen.id = almacen.almacen_id;
                                    almacen.quantity = almacen.stock;
                                    let alm = almacenes.value.filter((almac) => almac.id == almacen.almacen_id);
                                    almacen.name = alm && alm.length > 0 ? alm[0].name : '';                        
                                });
                                product.value.inventoryStatus = data.status ? data.status : 'INSTOCK'; 
                                productsOrig.value = products.value
                                toast.add({severity:'success', summary: 'Successful', detail: 'Actualizado correctamente', life: 3000});
                            }
                        });
                }                
                productDialogStock.value = false;
                productDialogGenericStock.value = false;
                productDialogStockDetail.value = false;
                product.value = {};
            }            
        };
        const addStock = (prod) => {
            product.value = {...prod};
            CrudService.updateCRUD('insumos','aumentar-stock', product.value).then((data) => {
                let validationErrors = [];
                if (data.status == 400) { 
                  this.displayErrors(data.data);
                } else {
                    products.value[findIndexById(data.data.id)] = data.data;
                    //product.value.inventoryStatus = data.status ? data.status : 'INSTOCK';
                    toast.add({severity:'success', summary: 'Successful', detail: 'Products Deleted', life: 3000});                    
                }
            });
        };
        const editProduct = (prod) => {
            product.value = {...prod};
            //product.value.proveedor_id = parseInt(product.value.proveedor_id)
            //let proveedor = proveedores.value.filter((prov) => prov.id == product.value.proveedor_id);
            //product.value.proveedor = proveedor
            //product.value.proveedor = '';
            let provider = proveedores.value.filter((prov) => prov.id == product.value.proveedor_id);
            if (provider && provider.length) {
                product.value.proveedor = provider[0];
            }
            product.value.unidad = parseInt(product.value.unidad)
            product.value.uses_unit = parseInt(product.value.uses_unit)
            product.value.inventoryStatus = getStatusName(product.value.status)            
            
            productDialog.value = true;
        };
        const editProductStock = (prod) => {
            product.value = {...prod};
            productDialogStock.value = true;
        };
        const editProductGenericStock = () => {
            let prod = products.value[0];
            product.value = {...prod};
            productDialogGenericStock.value = true;
        };
        const showStockDetail = (prod) => {
            product.value = {...prod};
            productDialogStockDetail.value = true;
        };
        const confirmDeleteProduct = (prod) => {
            product.value = prod;
            deleteProductDialog.value = true;
        };
        const deleteProduct = () => {
            // products.value = products.value.filter(val => val.id !== product.value.id);
            // deleteProductDialog.value = false;
            // product.value = {};
            // toast.add({severity:'success', summary: 'Successful', detail: 'Product Deleted', life: 3000});

            CrudService.deleteCRUD('insumos', 'insumo', product.value.id).then(
                (data) => {
                    if (data.status == 'error') {
                        toast.add({severity: "error",summary: "Oopsss!",detail: data.message, life: 3000,});
                        deleteProductDialog.value = false;
                        show_error.value = true;
                    } else {
                        products.value.splice(findIndexById(data.data.id), 1);
                        show_error.value = false;
                        deleteProductDialog.value = false;
                        toast.add({severity: "success",summary: "Éxito!",detail: "Eliminado correctamente.",life: 3000,});
                    }
                }
            );
        };
        const findIndexById = (id) => {
            let index = -1;
            for (let i = 0; i < products.value.length; i++) {
                if (products.value[i].id == id) {
                    index = i;
                    break;
                }
            }

            return index;
        };
        const createId = () => {
            let id = '';
            var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            for ( var i = 0; i < 5; i++ ) {
                id += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return id;
        };
        const filterStock = (id = null) => {
            if (id != null) {                
                filter_almacen_id.value = id;                
            }
            let almacs = almacenes.value.filter((item)=>item.id==filter_almacen_id.value);
            if (almacs.length && almacs.length>0) {
                almac.value = almacs[0].name;            
            }
            products.value = productsOrig.value;
            if (filter_almacen_id.value == 0) {
                products.value.forEach((item) => {
                    item.quantity = item.quantity_orig;
                });            
            } else {
                products.value.forEach((item) => { 
                    let warehouses = item.almacenes_insumos.filter((almac) => almac.id == filter_almacen_id.value);
                    item.quantity = warehouses && warehouses.length ? warehouses[0].stock : 0;
                    if (item.quantity <= 0) {
                        products.value = products.value.filter(val => val.id != item.id);
                    }
                });
            }
        };
        const exportCSV = () => {
            dt.value.exportCSV();
        };
        const confirmDeleteSelected = () => {
            deleteProductsDialog.value = true;
        };
        const deleteSelectedProducts = () => {
            products.value = products.value.filter(val => !selectedProducts.value.includes(val));
            deleteProductsDialog.value = false;
            selectedProducts.value = null;
            toast.add({severity:'success', summary: 'Successful', detail: 'Products Deleted', life: 3000});
        };

        const TransferStock = () => {
            /*
            if (! remito.value) {
                toast.add({severity:'error', summary: 'Atención!', detail: 'Debe ingresar el Nro de Remito!', life: 3000});
                return false;
            }
            if (! orden.value) {
                toast.add({severity:'error', summary: 'Atención!', detail: 'Debe ingresar el Nro de Orden de Compra!', life: 3000});
                return false;
            }
            */
            if (quantity.value <= 0) {
                toast.add({severity:'error', summary: 'Atención!', detail: 'Debe ingresar la cantidad!', life: 3000});
                return false;
            }
            if (! almacen_id.value) {
                toast.add({severity:'error', summary: 'Atención!', detail: 'Debe seleccionar el almacén!', life: 3000});
                return false;
            }
            if (! to_almacen_id.value) {
                toast.add({severity:'error', summary: 'Atención!', detail: 'Debe seleccionar el almacén destino!', life: 3000});
                return false;
            }
            if (almacen_id.value == to_almacen_id.value) {
                toast.add({severity:'error', summary: 'Atención!', detail: 'Debe seleccionar el almacén!', life: 3000});
                to_almacen_id.value = null;
                return false;
            }
            let almacen = almacenes.value.filter((item) => item.id == almacen_id.value);
            if (! almacen || almacen.length <= 0) {
                toast.add({severity:'error', summary: 'Atención!', detail: 'Por favor intente nuevamente!', life: 3000});
                almacen_id.value = null;
                to_almacen_id.value = null;
                return false; 
            }
            let almacen2 = almacenes.value.filter((item) => item.id == to_almacen_id.value);
            if (! almacen || almacen.length <= 0) {
                toast.add({severity:'error', summary: 'Atención!', detail: 'Por favor intente nuevamente!', life: 3000});
                almacen_id.value = null;
                to_almacen_id.value = null;
                return false; 
            }
          
          if (product.value.almacenes_insumos && product.value.almacenes_insumos.length > 0) {
            let index = product.value.almacenes_insumos.findIndex(item => item.id == almacen_id.value);
            let to_index = product.value.almacenes_insumos.findIndex(item => item.id == to_almacen_id.value);
            //product.value.almacenes_insumos[index].remito = remito.value; 
            //product.value.almacenes_insumos[index].fecha_remito = fecha_remito.value; 
            //product.value.almacenes_insumos[index].orden = orden.value; 
            if (index !== -1) {
                if (parseInt(product.value.almacenes_insumos[index].quantity) < parseInt(quantity.value)) {
                    quantity.value = parseInt(product.value.almacenes_insumos[index].quantity);
                    return false;
                }
                product.value.almacenes_insumos[index].quantity = parseInt(product.value.almacenes_insumos[index].quantity) - parseInt(quantity.value); 
            }
            if (to_index !== -1) {
                product.value.almacenes_insumos[to_index].quantity = parseInt(product.value.almacenes_insumos[to_index].quantity) + parseInt(quantity.value);                
            } else {
                product.value.almacenes_insumos.push({
                    id: to_almacen_id.value,
                    name: almacen2[0].name,
                    quantity: quantity.value,
                    remito: remito.value,
                    fecha_remito: fecha_remito.value,
                    orden: orden.value,
                });
            }
          }

          quantity.value = 0;
          almacen_id.value = null;
          to_almacen_id.value = null;
          //remito.value = null;
          //fecha_remito.value = null;
          //orden.value = null;
        };

        const TransferGenericStock = () => {            
            if (quantity.value <= 0) {
                toast.add({severity:'error', summary: 'Atención!', detail: 'Debe ingresar la cantidad!', life: 3000});
                return false;
            }
            if (! almacen_id.value) {
                toast.add({severity:'error', summary: 'Atención!', detail: 'Debe seleccionar el almacén!', life: 3000});
                return false;
            }
            let almacen = almacenes.value.filter((item) => item.id == almacen_id.value);
            if (! almacen || almacen.length <= 0) {
                toast.add({severity:'error', summary: 'Atención!', detail: 'Por favor intente nuevamente!', life: 3000});
                almacen_id.value = null;
                return false; 
            }

          if (product.value.almacenes_insumos && product.value.almacenes_insumos.length > 0) {
            let index = product.value.almacenes_insumos.findIndex(item => item.id == almacen_id.value);
            if (index !== -1) {          
                product.value.almacenes_insumos[index].remito = remito.value; 
                product.value.almacenes_insumos[index].fecha_remito = fecha_remito.value; 
                product.value.almacenes_insumos[index].orden = orden.value; 
                product.value.almacenes_insumos[index].quantity = parseInt(product.value.almacenes_insumos[index].quantity) + parseInt(quantity.value); 
            }
          }

          quantity.value = 0;
          almacen_id.value = null;          
        };

        const delItemAlmacen = (item_id) => {
          let index = product.value.almacenes_insumos.findIndex(item => item.id == item_id);
          product.value.almacenes_insumos.splice(index, 1);
          product.value.quantity = product.value.almacenes_insumos.reduce((a, b) => a + parseInt(b['quantity']), 0);
        };

        const getQuantities = (data) => {
            let items = data.almacenes_insumos;
            let tooltip = 'Sin stock';
            if (items && items.length) {
                tooltip = '';
                items.forEach((item) => {
                    let warehouse = almacenes.value.filter((warehouse) => warehouse.id == item.almacen_id);
                    if (warehouse && warehouse.length) {
                        tooltip += warehouse[0].name + ': ' + item.quantity + '<br />';
                    }
                });
            }
            return tooltip;
        };

        const addItemDetalle = () => {
          if (quantity.value <= 0) {
            toast.add({severity:'error', summary: 'Atención!', detail: 'Debe ingresar la cantidad!', life: 3000});
            return false;
          }
          if (! almacen_id.value) {
            toast.add({severity:'error', summary: 'Atención!', detail: 'Debe seleccionar el almacén!', life: 3000});
            return false;
          }
          let almacen = almacenes.value.filter((item) => item.id == almacen_id.value);
          if (! almacen || almacen.length <= 0) {
            toast.add({severity:'error', summary: 'Atención!', detail: 'Por favor intente nuevamente!', life: 3000});
            almacen_id.value = null;
            return false; 
          }
          
          if (product.value.almacenes_insumos && product.value.almacenes_insumos.length > 0) {
            let index = product.value.almacenes_insumos.findIndex(item => item.id == almacen_id.value);
            if (index !== -1) {
                product.value.almacenes_insumos[index].quantity = quantity.value;
                product.value.almacenes_insumos[index].remito = remito.value;
                product.value.almacenes_insumos[index].fecha_remito = fecha_remito.value;
                product.value.almacenes_insumos[index].orden = orden.value;
            } else {
                product.value.almacenes_insumos.push({
                    id: almacen_id.value,
                    name: almacen[0].name,
                    quantity: quantity.value,
                    remito: remito.value,
                    fecha_remito: fecha_remito.value,
                    orden: orden.value
                });
            }
          } else {
            product.value.almacenes_insumos = [{
                id: almacen_id.value,
                name: almacen[0].name,
                quantity: quantity.value,
                remito: remito.value,
                fecha_remito: fecha_remito.value,
                orden: orden.value
              }];
          } 
          almacen_id.value = null;
          quantity.value = 0;
          product.value.quantity = product.value.almacenes_insumos.reduce((a, b) => a + parseInt(b['quantity']), 0);
        };

        return { dt, products, productDialog, productDialogStock, productDialogGenericStock, editProductGenericStock, productDialogStockDetail, deleteProductDialog, show_error, deleteProductsDialog, product, 
            selectedProducts, filters, submitted, statuses, units, formatCurrency, openNew, hideDialog, hideDialogStock, hideDialogGenericStock, saveProduct, saveProductStock, saveProductGenericStock, editProduct, editProductStock, showStockDetail, addStock, formatUnity, searchProvider, searchInsumo, getStatusName, confirmDeleteProduct, deleteProduct, findIndexById, createId, exportCSV, filterStock, confirmDeleteSelected, deleteSelectedProducts, estados, delItemAlmacen, addItemDetalle, almacenes, almacenes_filtro, almacenes_full, filter_almacen_id, almacen_id, to_almacen_id, remito, fecha_remito, orden, quantity, TransferStock, TransferGenericStock, proveedores, almac, getQuantities, productsOrig, filteredProvider, filteredInsumo, newItemProvider, newItemInsumo, selectedProvider, selectedInsumo }

    }
}
</script>

<style lang="scss" scoped>
.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}

.product-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .product-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}

.product-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.product-badge.status-instock {
    background: #c8e6c9;
    color: #256029;
}

.product-badge.status-stock {
    background: #FBAE4A;
    color: #373636;
}

.product-badge.status-lowstock {
    background: #feedaf;
    color: #8a5340;
}

.product-badge.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
}

.p-tooltip .p-tooltip-text {
     border-radius: 3px !important;
   }
  .p-tooltip.p-tooltip-right .p-tooltip-arrow {
     border-right-color: #304562 !important;
   }
  .p-tooltip.p-tooltip-left .p-tooltip-arrow {
     border-left-color: #304562 !important;
   }
  .p-tooltip.p-tooltip-top .p-tooltip-arrow {
     border-top-color: #304562 !important;
   }
 .p-tooltip.p-tooltip-bottom .p-tooltip-arrow {
     border-bottom-color: #304562 !important;
 }
  .st_bg_color { 
    padding-top: 5px;
    font-size: 1.1rem;
    height: 2.5rem;
    border: 1px solid #C80D0D;
    background-color: #EEA2A2;
    & >div i {
        color: #FF9800;
    }
  }
</style>